module.exports = __webpack_public_path__ + "static/media/nav_card_icon_3.a76e7817.svg";